import { Checkbox } from "@mui/material";

interface RowCheckboxProps {
  id: number;
  departmentId: number;
  selectedIds: number[];
  selectedDepartmentIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedDepartmentIds: React.Dispatch<React.SetStateAction<number[]>>;
  notFolioSelected: number[];
  notDepartmentSelected: number[];
  setNotFolioSelected: React.Dispatch<React.SetStateAction<number[]>>;
  setNotDepartmentSelected: React.Dispatch<React.SetStateAction<number[]>>;
  total: number;
  isChecked:boolean 
}

export const RowCheckbox: React.FC<RowCheckboxProps> = ({
  id,
  departmentId,
  selectedIds,
  selectedDepartmentIds,
  setSelectedIds,
  setSelectedDepartmentIds,
  notFolioSelected,
  notDepartmentSelected,
  setNotFolioSelected,
  setNotDepartmentSelected,
  total,
  isChecked
}) => {
  const isHeaderSelected =  isChecked; //selectedIds.length + notFolioSelected.length === total;

  // Helper function to remove only first occurrence of an id
  const removeFirstOccurrence = (arr: number[], valueToRemove: number) => {
    const index = arr.indexOf(valueToRemove);
    if (index === -1) return arr;
    return [...arr.slice(0, index), ...arr.slice(index + 1)];
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isHeaderSelected) {
      if (event.target.checked) {
        /* setSelectedIds(prev => [...prev, id]);
        setSelectedDepartmentIds(prev => [...prev, departmentId]); */
        setNotFolioSelected(prev => removeFirstOccurrence(prev, id));
        setNotDepartmentSelected(prev => removeFirstOccurrence(prev, departmentId));
      } else {
        /* setSelectedIds(prev => removeFirstOccurrence(prev, id));
        setSelectedDepartmentIds(prev => removeFirstOccurrence(prev, departmentId)); */
        setNotFolioSelected(prev => [...prev, id]);
        setNotDepartmentSelected(prev => [...prev, departmentId]);
      }
    } else {
      if (event.target.checked) {
        setSelectedIds(prev => [...prev, id]);
        setSelectedDepartmentIds(prev => [...prev, departmentId]);
      } else {
        setSelectedIds(prev => removeFirstOccurrence(prev, id));
        setSelectedDepartmentIds(prev => removeFirstOccurrence(prev, departmentId));
      }
    }
  };

  return (
    <Checkbox
      checked={isChecked ? !notFolioSelected.includes(id) : selectedIds.includes(id)}
      onChange={handleCheckboxChange}
      color="primary"
    />
  );
};